// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products_container {
  background-color: var(--ColorThirdDark);
  margin: 1rem;
  display: flex;
  flex-direction: row;
  max-height: 70%;
  overflow: hidden;
}
.products_category_container {
  display: flex;
  flex-direction: column;
  max-width: 82%;
  overflow: hidden;
  height: 80%;
  margin: 2rem;
}
.products_category_box {
  height: 700px;
  margin: 1rem;
  width: 100%;
}
.products_category_text{
  font-weight: bolder;
  font-size: medium;
}
.products_navbar {
  background-color: var(--ColorShadow);
  border-right: 2px solid var(--ColorSecondaryDark);
  padding: 1vw;
  min-width: 230px;
  display: flex;
  flex-direction: column;
}

.ative{
  transition: all 0.5s ease-in-out;
  font-size: large;
  font-weight: bold;
  color: var(--ColorSecondaryDark);
}
.category_item{
  margin: 1rem;
  transition: all 0.5s ease-in-out;
}

.category_item:hover{
  cursor: pointer;
}
.category_item_all{
  margin-top: 2rem;
  margin-left: 10px;
}
.category_item_all:hover{
 cursor: pointer;
}
.button_update_order {
  margin-top: 5px;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--ColorSecondaryDark);
  color: white;
  font-weight: 900;
  border-radius: 20px;
  padding: 1rem;
  z-index: 1;
  bottom: 0;
  gap: 5px;
  height: 30px;

}
.products_navbar_item:last-child button {
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--ColorSecondaryDark);
  color: white;
  font-weight: 900;
  border-radius: 20px;
  padding: 1rem;
  gap: 5px;
}
.products_navbar h3 {
  margin: 0;
  margin-bottom: 2rem;
  color: var(--ColorSecondaryDark);
  border-bottom: 2px solid var(--ColorSecondaryDark);
  text-align: center;
}


.grid-container {
  display: flex;
  justify-content: center;
  width: 100%;  
}

.grid-container-bottom {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Restaurant/RestaurantPage.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,iDAAiD;EACjD,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;CACC,eAAe;AAChB;AACA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,SAAS;EACT,QAAQ;EACR,YAAY;;AAEd;AACA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,kDAAkD;EAClD,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".products_container {\n  background-color: var(--ColorThirdDark);\n  margin: 1rem;\n  display: flex;\n  flex-direction: row;\n  max-height: 70%;\n  overflow: hidden;\n}\n.products_category_container {\n  display: flex;\n  flex-direction: column;\n  max-width: 82%;\n  overflow: hidden;\n  height: 80%;\n  margin: 2rem;\n}\n.products_category_box {\n  height: 700px;\n  margin: 1rem;\n  width: 100%;\n}\n.products_category_text{\n  font-weight: bolder;\n  font-size: medium;\n}\n.products_navbar {\n  background-color: var(--ColorShadow);\n  border-right: 2px solid var(--ColorSecondaryDark);\n  padding: 1vw;\n  min-width: 230px;\n  display: flex;\n  flex-direction: column;\n}\n\n.ative{\n  transition: all 0.5s ease-in-out;\n  font-size: large;\n  font-weight: bold;\n  color: var(--ColorSecondaryDark);\n}\n.category_item{\n  margin: 1rem;\n  transition: all 0.5s ease-in-out;\n}\n\n.category_item:hover{\n  cursor: pointer;\n}\n.category_item_all{\n  margin-top: 2rem;\n  margin-left: 10px;\n}\n.category_item_all:hover{\n cursor: pointer;\n}\n.button_update_order {\n  margin-top: 5px;\n  border: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--ColorSecondaryDark);\n  color: white;\n  font-weight: 900;\n  border-radius: 20px;\n  padding: 1rem;\n  z-index: 1;\n  bottom: 0;\n  gap: 5px;\n  height: 30px;\n\n}\n.products_navbar_item:last-child button {\n  border: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--ColorSecondaryDark);\n  color: white;\n  font-weight: 900;\n  border-radius: 20px;\n  padding: 1rem;\n  gap: 5px;\n}\n.products_navbar h3 {\n  margin: 0;\n  margin-bottom: 2rem;\n  color: var(--ColorSecondaryDark);\n  border-bottom: 2px solid var(--ColorSecondaryDark);\n  text-align: center;\n}\n\n\n.grid-container {\n  display: flex;\n  justify-content: center;\n  width: 100%;  \n}\n\n.grid-container-bottom {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
